<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-toolbar card color="info" dark>
          <v-toolbar-title class="body-2">
            <a
              :href="`/print-invoice/${item.id}`"
              target="_blank"
              class="print-link"
              title="Imprimir detalles"
            >
              <img src="/static/impresora.svg" class="icon-printer" />
            </a>
            <div class="details-invoice-number-title">
              {{ item.invoiceNumber }}
            </div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('close-detail')" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-text-field
                  label="Laboratorio"
                  readonly
                  v-model="item.lab_invoices.name"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  label="Distribuidor"
                  readonly
                  v-model="item.dist_invoices.name"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  label="Factura"
                  readonly
                  v-model="item.invoiceNumber"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-input
                  class="v-text-field-numeric v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light"
                  label="# CIF"
                >
                  <vue-numeric
                    readonly
                    disabled
                    separator=","
                    v-bind:minus="false"
                    v-bind:precision="2"
                    v-model="item.cif"
                  ></vue-numeric>
                </v-input>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  label="Bulto"
                  readonly
                  v-model="item.packageNumber"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  label="Control"
                  readonly
                  v-model="item.controlNumber"
                ></v-text-field>
              </v-flex>
              <v-flex md12 xs12 v-if="item.observations">
                <v-textarea
                  data-vv-name="address"
                  label="Observaciones"
                  readonly
                  no-resize
                  v-model="item.observations"
                ></v-textarea>
              </v-flex>

              <v-flex lg12 sm12>
                <div class="v-table__overflow">
                  <table
                    class="v-datatable v-table v-datatable--select-all theme--light"
                  >
                    <thead>
                      <tr>
                        <th class="text-sm-left">Producto</th>
                        <th class="text-sm-left">Formula</th>
                        <th class="text-sm-left">Reg Sanitario</th>
                        <th class="text-sm-left"># de Lote</th>
                        <th class="text-sm-left">Expiracion</th>
                        <th class="text-sm-left">Certificados</th>
                        <th class="text-sm-left">Estatus</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr :key="i" v-for="(obj, i) in item.products">
                        <td class="text-sm-left">{{ obj.product.name }}</td>
                        <td class="text-sm-left">{{ obj.fxFormula }}</td>
                        <td class="text-sm-left">{{ obj.sanitaryReg }}</td>
                        <td class="text-sm-left">{{ obj.batchNumber }}</td>
                        <td class="text-sm-left">
                          {{ dateFormat(obj.expirationDate) }}
                        </td>
                        <td class="text-sm-left">
                          {{ obj.certificate ? 'SI' : 'NO' }}
                        </td>
                        <td class="text-sm-left">
                          <v-chip
                            :color="getColorByStatus(obj.batchStatus)"
                            label
                            small
                            text-color="white"
                            >{{ getLabelByStatus(obj.batchStatus) }}</v-chip
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  getColorByStatus,
  getLabelByStatus,
  dateFormat,
} from '@/helpers/TransitHelper'
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dateFormat,
    getColorByStatus,
    getLabelByStatus,
  },
}
</script>
<style scope="css">
.v-text-field-numeric .v-label {
  position: absolute !important;
  transform: translateY(-18px) scale(0.75);
}
.details-invoice-number-title {
  display: inline-block;
  position: relative;
  top: -10px;
}
.print-link {
  display: inline-block;
  margin-right: 10px;
}
.icon-printer {
  display: inline-block;
  width: 28px;
  height: 28px;
  filter: invert(1);
}
</style>
